export enum APIEndpoints {
    /** Get List of Crosstabs */
    CROSSTAB_LIST = '/crosstab/org/list',
    /** Create a new Crosstab */
    CROSSTAB = '/crosstab',
    PUBLISH_CROSSTAB = '/crosstab/publish',
}

export enum ConfidenceLevel {
    'NONE' = 0,
    'NINETY' = 1.645,
    'NINETYFIVE' = 1.96,
    'NINETYNINE' = 2.576,
}

/** Helper functions for dynamic endpoints */
export const DYNAMIC_ENDPOINTS = {
    DUPLICATE_CROSSTAB: (crosstabId: string, projectId: number, surveyId?: number) =>
        `/crosstab/import/${crosstabId}/${projectId}${surveyId ? `/${surveyId}` : ''}`,
    CREATE_CROSSTAB: (projectId: number, surveyId: number | null) =>
        `/crosstab/create/${projectId}${surveyId ? `/${surveyId}` : ''}`,
} as const;

export const SURVEY_TABS = {
    MY_SURVEYS: {
        key: 'my-surveys',
        title: 'My Surveys',
    },
    SURVEY_PULSE: {
        key: 'survey-pulse',
        title: 'Monthly Opinions',
    },
} as const;
